import { useEffect } from 'react';

import { NavigationType, useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTopOnNavigation = () => {
  const { hash, pathname, search } = useLocation();
  const navigationType = useNavigationType();

  useEffect(function startEachNewPageAtTheTop() {
    const isHistoryStep = navigationType === NavigationType.Pop;
    if (!isHistoryStep && !hash) {
      window.scrollTo(0, 0);
    }
  }, [hash, navigationType, pathname, search]);

  return null;
};

export default ScrollToTopOnNavigation;
